import React, { FC } from "react"
import styled from "styled-components"
import { TestableComponent } from "../../e2e-tests/utils/locator-utils"
import { Collapsible, CollapsibleProps } from "../collapsible/Collapsible"
import { theme } from "../../util/styles/theme"
import { Box, BoxProps } from "../box/Box"

export type CardProps = CollapsibleProps &
  Pick<
    BoxProps,
    "backgroundColor" | "shadow" | "size" | "className" | "bottomMargin"
  >

const StyledCollapsible = styled(Collapsible)`
  ${theme.textStyle("default", "medium", "normal")}

  border: 0;
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%; // Needed for IE11
  height: 100%;
`

const StyledBox = styled(Box)`
  @media print {
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.greyDark};
  }
`

export const Card: FC<CardProps> & TestableComponent = ({
  isInitiallyCollapsed,
  isCollapsible,
  children,
  className,
  ...rest
}) => {
  return (
    <StyledBox
      className={`${Card.testClassName} ${className ?? ""}`}
      {...rest}
      padding={false}
    >
      <StyledCollapsible
        isCollapsible={isCollapsible}
        isInitiallyCollapsed={isInitiallyCollapsed}
      >
        {children}
      </StyledCollapsible>
    </StyledBox>
  )
}
Card.testClassName = "card"

Card.defaultProps = {
  backgroundColor: "white",
  isCollapsible: false,
  size: "medium",
}
